import React from 'react'
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import emailjs from 'emailjs-com';

function ContactUs() {

  function sendEmail(e){
    e.preventDefault();

    emailjs.sendForm('gmail', 'template_jm8brvr', e.target, 'user_DVkCn6sJmLJdYOQmlrpjj')
      .then((result) => {
          console.log(result.text);
      }, (error) => {
          console.log(error.text);
      });

      e.target.reset()
  }
    return (
        <div className= "contactmain">
            
    

      
           <a href="https://github.com/jb1998" target="_blank" rel="noopener noreferrer"> <i class="fab fa-3x fa-github style-icon"></i></a> 
           <a href="https://www.linkedin.com/in/jb1998/" target="_blank" rel="noopener noreferrer"> <i class="fab fa-3x  fa-linkedin style-icon"></i></a> 
           <a href="mailto:jatinbindra.dev@gmail.com" target="_blank" rel="noopener noreferrer">   <i class="fas fa-3x fa-envelope-open style-icon"></i></a> 
           <a href="https://www.facebook.com/jatin.bindra.104/" target="_blank" rel="noopener noreferrer">  <i class="fab fa-3x fa-facebook-square style-icon"></i></a> 
           {/* <a href="https://drive.google.com/file/d/1qi3-q4YWnyF535564-DtFrQIUp0gjVB7/view?usp=sharing" target="_blank" rel="noopener noreferrer"> <i class="far fa-3x fa-file style-icon"></i></a>  */}

      
 
       
        
    </div>
    )
}

export default ContactUs
